import { kstShort, assigneeNames, registrarLabel } from "./view";
import { StatusBadge, ChannelBadge } from "./Badges";

const Who = ({ q }) =>
    q.assignees?.length ? <>{assigneeNames(q)}</> : (
        <><span className="none">미지정</span>{q.is_late && <span className="late" title="접수 후 2시간 넘게 담당자가 없습니다">지연</span>}</>
    );
const schedule = (q) => (q.schedule?.date ? `${q.schedule.date.slice(5)} ${q.schedule.time || ""}`.trim() : "");
// 안 읽음(빨강)·가맹점주 새 글(주황) 점, 재문의 표시 — 계약 §4-1 unread · customer_new_post · reopened_from_id
const Marks = ({ q }) => (
    <>
        {q.unread && <span className="newdot" title="아직 안 읽음"></span>}
        {q.customer_new_post && <span className="newdot post" title="가맹점주 새 글"></span>}
    </>
);
const Reopen = ({ q }) => (q.reopened_from_id ? <> <span className="tag tag-gen" title={`이전 문의 No.${q.reopened_from_id}`}>재문의</span></> : null);

export default function InquiryTable({ items, total, grandTotal, selId, meta, onOpen }) {
    return (
        <div className="view-list">
            <div className="tbl-wrap">
                <table className="tbl">
                    <thead><tr>
                        <th>No</th><th>진행상태</th><th>경로</th><th>구분</th><th>상호명</th><th>요청 내용</th>
                        <th>일정</th><th>담당자</th><th>등록인</th><th>등록일</th><th>처리일시</th>
                    </tr></thead>
                    <tbody>
                        {items.length === 0 ? (
                            <tr><td colSpan={11}><div className="empty">조건에 맞는 문의가 없습니다</div></td></tr>
                        ) : items.map((q) => (
                            <tr key={q.id} className={selId === q.id ? "sel" : ""} onClick={() => onOpen(q.id)}>
                                <td className="c-no">{q.id}</td>
                                <td><StatusBadge status={q.status} meta={meta} /></td>
                                <td><ChannelBadge channel={q.channel} /></td>
                                <td className="ty">{q.category?.label}<small>{q.subcategory?.label}</small></td>
                                <td><Marks q={q} /><b>{q.store?.name}</b><Reopen q={q} /></td>
                                <td className="c-req" title={q.request_content}>{q.request_content}</td>
                                <td className="c-dt" style={{ color: "var(--st-ing)" }}>{schedule(q)}</td>
                                <td><Who q={q} /></td>
                                <td style={{ color: "var(--tx2)" }}>{registrarLabel(q.registrar)}</td>
                                <td className="c-dt">{kstShort(q.created_at)}</td>
                                <td className="c-dt">{kstShort(q.completed_at)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="mcards">
                {items.length === 0 ? <div className="empty">조건에 맞는 문의가 없습니다</div> : items.map((q) => (
                    <div key={q.id} className="mc" onClick={() => onOpen(q.id)}>
                        <div className="mc-top"><StatusBadge status={q.status} meta={meta} /><ChannelBadge channel={q.channel} /><Reopen q={q} /><span className="t">No.{q.id} · {kstShort(q.created_at)}</span></div>
                        <b><Marks q={q} />{q.store?.name}</b>
                        <p><span className="ty">{q.category?.label}<small>{q.subcategory?.label}</small></span> {q.request_content}</p>
                        <div className="mc-foot">
                            <span>{q.assignees?.length ? <><i className="fa-regular fa-user"></i> </> : null}<Who q={q} /></span>
                            {schedule(q) && <span style={{ color: "var(--st-ing)" }}><i className="fa-regular fa-calendar"></i> {schedule(q)}</span>}
                        </div>
                    </div>
                ))}
            </div>
            <div className="tbl-foot"><span>{total}건 / 전체 {grandTotal}건</span><span className="mhide">행을 누르면 상세 화면이 열립니다</span></div>
        </div>
    );
}
